/* Gifty spin wheel. Pops once, 3s after page load. If dismissed (spun
   or not) it never auto-shows again. Rendered from layout/theme.liquid behind
   settings.gifty_99_active. No PII in analytics: events carry the won tier (a
   number) and a campaign tag only. */
(function () {
  'use strict';

  var root = document.getElementById('g99');
  var cfgEl = document.getElementById('gifty99-config');
  if (!root || !cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ---------- state ---------- */
  var STORE_KEY = 'gifty99';
  function readState() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
  }
  function writeState(patch) {
    var s = readState();
    for (var k in patch) { if (patch.hasOwnProperty(k)) s[k] = patch[k]; }
    try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
    return s;
  }

  /* ---------- analytics ---------- */
  function deviceClass() {
    var w = window.innerWidth;
    return w < 760 ? 'mobile' : (w < 990 ? 'tablet' : 'desktop');
  }
  // gtag.js is loaded by a third-party app, not this theme, so its readiness
  // relative to the 3s auto-open is not guaranteed. Retry briefly rather than
  // silently drop the event (same pattern as assets/gifty-analytics.js).
  function track(name, params, retriesLeft) {
    var payload = Object.assign({ campaign: '9-9-2026', device_class: deviceClass() }, params || {});
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }
    retriesLeft = retriesLeft === undefined ? 12 : retriesLeft;
    if (retriesLeft <= 0) return;
    setTimeout(function () { track(name, params, retriesLeft - 1); }, 300);
  }

  /* ---------- helpers ---------- */
  // U+202F (narrow no-break space) after the peso sign: the Onest glyph's
  // crossbar otherwise collides with the next digit and reads as a strikethrough.
  function money(cents) {
    return '₱ ' + Math.round(cents / 100).toLocaleString('en-PH');
  }
  function setSlot(name, value) {
    var el = root.querySelector('[data-g99-slot="' + name + '"]');
    if (el) el.textContent = value;
  }
  function showState(name) {
    var nodes = root.querySelectorAll('[data-g99-state]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].hidden = nodes[i].getAttribute('data-g99-state') !== name;
    }
  }

  setSlot('headline', CFG.headline);
  setSlot('subline', CFG.subline);

  /* ---------- confetti ---------- */
  var confettiHost = document.getElementById('g99-confetti');
  function burstConfetti() {
    if (!confettiHost) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#FF66B2', '#FFCC66', '#ffffff', '#D81B60', '#FF9ED2'];
    var frag = document.createDocumentFragment();
    for (var i = 0; i < 34; i++) {
      var p = document.createElement('i');
      p.style.left = Math.random() * 100 + '%';
      p.style.background = colors[i % colors.length];
      p.style.animationDuration = (2.2 + Math.random() * 1.6) + 's';
      p.style.animationDelay = (Math.random() * 0.35) + 's';
      p.style.transform = 'translateY(-10px) rotate(' + (Math.random() * 360) + 'deg)';
      frag.appendChild(p);
    }
    confettiHost.innerHTML = '';
    confettiHost.appendChild(frag);
    setTimeout(function () { if (confettiHost) confettiHost.innerHTML = ''; }, 4200);
  }

  /* ---------- sound (Web Audio, synthesised, no asset) ---------- */
  var actx = null;
  var muted = false;
  try { muted = localStorage.getItem('gifty99muted') === '1'; } catch (e) {}
  function unlockAudio() {
    if (muted) return;
    try {
      if (!actx) actx = new (window.AudioContext || window.webkitAudioContext)();
      if (actx.state === 'suspended') actx.resume();
    } catch (e) { actx = null; }
  }
  function tick(when, freq, gainv, dur) {
    if (!actx) return;
    var o = actx.createOscillator(), g = actx.createGain();
    o.type = 'square'; o.frequency.value = freq;
    g.gain.setValueAtTime(0.0001, when);
    g.gain.exponentialRampToValueAtTime(gainv, when + 0.004);
    g.gain.exponentialRampToValueAtTime(0.0001, when + dur);
    o.connect(g); g.connect(actx.destination);
    o.start(when); o.stop(when + dur + 0.02);
  }
  function playSpinSound(ms) {
    if (muted || !actx) return;
    var t = actx.currentTime, total = ms / 1000;
    // ticks that fan out from ~45ms apart to ~320ms apart, mimicking the deceleration
    var elapsed = 0, gap = 0.045;
    while (elapsed < total - 0.15) {
      var p = elapsed / total;
      tick(t + elapsed, 1400 - p * 500, 0.05 * (1 - p * 0.5), 0.03);
      gap = 0.045 + p * p * 0.30;
      elapsed += gap;
    }
  }
  function playWinSound() {
    if (muted) return;
    unlockAudio();
    if (!actx) return;
    var t = actx.currentTime;
    var notes = [523.25, 659.25, 783.99, 1046.5]; // C5 E5 G5 C6
    notes.forEach(function (f, i) {
      var o = actx.createOscillator(), g = actx.createGain();
      o.type = 'triangle'; o.frequency.value = f;
      var when = t + i * 0.09;
      g.gain.setValueAtTime(0.0001, when);
      g.gain.exponentialRampToValueAtTime(0.16, when + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, when + 0.45);
      o.connect(g); g.connect(actx.destination);
      o.start(when); o.stop(when + 0.5);
    });
  }
  function setMuted(v) {
    muted = v;
    try { localStorage.setItem('gifty99muted', v ? '1' : '0'); } catch (e) {}
    var b = document.getElementById('g99-mute');
    if (b) { b.setAttribute('aria-pressed', String(v)); b.textContent = v ? '🔇' : '🔊'; }
  }

  /* ---------- modal open / close ---------- */
  var lastFocus = null;
  var armed = true;
  var titleEl = root.querySelector('.g99__title');
  var sayEl = root.querySelector('.g99__say');
  var wonPrize = null;

  function buildRevealFromState(s) {
    wonPrize = { amount: s.tier, code: s.code };
    setSlot('prize2', money(s.tier * 100) + ' OFF');
    setSlot('code', s.code);
    setSlot('revealfine', 'Saved on this device. One use per customer at checkout.');
    document.getElementById('g99-claim-link').href =
      '/discount/' + s.code + '?redirect=' + encodeURIComponent(CFG.pdpUrl);
    titleEl.textContent = 'Your Gifty prize';
    sayEl.textContent = '';
    showState('reveal');
  }

  var closeTimer = null;
  function openModal(trigger) {
    armed = false;
    lastFocus = document.activeElement;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // commit the closed state, then add .is-open so the CSS transition runs.
    // A forced reflow is more reliable than rAF (which is throttled in hidden tabs).
    void root.offsetWidth;
    root.style.opacity = '';
    root.classList.add('is-open');
    // safety net: if the transition never progresses (throttled tab, heavy load)
    // force the open state so the modal is never left invisible.
    setTimeout(function () {
      if (!root.hidden && root.classList.contains('is-open')) root.style.opacity = '1';
    }, 550);
    if (!readState().seenAt) writeState({ seenAt: Date.now() });
    var s = readState();
    if (s.spunAt && s.code) {
      buildRevealFromState(s);
    } else {
      showState('intro');
      titleEl.textContent = CFG.headline;
      sayEl.textContent = CFG.subline;
      if (!readState().spunAt) {
        spinButtons.forEach(function (b) { if (b) b.disabled = false; });
      }
      var cta = document.getElementById('g99-spin-cta');
      if (cta) cta.focus();
    }
    track('spin_wheel_shown', { trigger: trigger });
  }

  function closeModal() {
    root.style.opacity = '';
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var delay = reduceMotion() ? 0 : 240;
    closeTimer = setTimeout(function () { root.hidden = true; }, delay);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-g99-close')) {
      if (!readState().spunAt) track('spin_wheel_dismissed', {});
      closeModal();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;
    // simple focus trap: keep Tab within the modal
    var f = root.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    var vis = [];
    for (var i = 0; i < f.length; i++) {
      var el = f[i];
      if (!el.disabled && el.getClientRects().length) vis.push(el);
    }
    if (!vis.length) return;
    var first = vis[0], last = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (vis.indexOf(document.activeElement) === -1) { e.preventDefault(); first.focus(); }
  });

  /* ---------- spin ---------- */
  function weightedPick(prizes) {
    var total = 0, i;
    for (i = 0; i < prizes.length; i++) total += prizes[i].weight;
    var r = Math.random() * total;
    for (i = 0; i < prizes.length; i++) {
      r -= prizes[i].weight;
      if (r <= 0) return prizes[i];
    }
    return prizes[prizes.length - 1];
  }
  function segmentAngleFor(amount) {
    var segs = CFG.segments, idxs = [], i;
    for (i = 0; i < segs.length; i++) if (segs[i] === amount) idxs.push(i);
    if (!idxs.length) idxs = [0];
    var chosen = idxs[Math.floor(Math.random() * idxs.length)];
    var per = 360 / segs.length;
    // wedges are centered on multiples of `per` (segmentCentered), so the wedge
    // centre angle is chosen*per; a tiny jitter keeps repeat wins from looking identical
    return chosen * per + (Math.random() * 0.5 - 0.25) * per;
  }

  var disc = document.getElementById('g99-disc');
  var spinButtons = [document.getElementById('g99-spin'), document.getElementById('g99-spin-cta')];
  var spinning = false;

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function doSpin() {
    if (spinning || readState().spunAt) return;
    spinning = true;
    spinButtons.forEach(function (b) { if (b) b.disabled = true; });
    wonPrize = weightedPick(CFG.prizes);
    writeState({ spunAt: Date.now(), tier: wonPrize.amount, code: wonPrize.code });
    track('spin_wheel_spun', { tier_won: wonPrize.amount });

    var reduce = reduceMotion();
    var target = segmentAngleFor(wonPrize.amount);
    var base = 360 - target;
    // reduced motion still spins, just shorter and gentler (a prize wheel that
    // does not visibly turn reads as broken).
    var turns = reduce ? 2 : 6;
    var dur = reduce ? 1300 : 4200;
    var finalRot = 360 * turns + base;

    if (!disc) { setTimeout(showWin, 50); return; }

    playSpinSound(dur);

    // set the transition inline and force a reflow so it animates from the
    // element's current transform rather than snapping to the end value.
    disc.style.transition = 'transform ' + dur + 'ms cubic-bezier(.16,.67,.13,1)';
    void disc.getBoundingClientRect();
    disc.style.transform = 'rotate(' + (finalRot + 5) + 'deg)';
    setTimeout(function () {
      disc.style.transition = 'transform 420ms ease-out';
      disc.style.transform = 'rotate(' + finalRot + 'deg)';
      setTimeout(showWin, 440);
    }, dur);
  }
  spinButtons.forEach(function (b) { if (b) b.addEventListener('click', function () { unlockAudio(); doSpin(); }); });

  var muteBtn = document.getElementById('g99-mute');
  if (muteBtn) {
    setMuted(muted);
    muteBtn.addEventListener('click', function () {
      setMuted(!muted);
      if (!muted) unlockAudio();
    });
  }

  /* ---------- win + capture ---------- */
  function showWin() {
    spinning = false;
    var off = wonPrize.amount;
    var discounted = CFG.priceCents - off * 100;
    setSlot('prize', money(off * 100) + ' OFF');
    setSlot('prize2', money(off * 100) + ' OFF');
    setSlot('priceline', 'Your personalized song, ' + money(CFG.priceCents) + ' becomes ' + money(discounted));
    setSlot('code', wonPrize.code);
    setSlot('revealfine', 'Saved on this device. One use per customer at checkout.');
    document.getElementById('g99-claim-link').href =
      '/discount/' + wonPrize.code + '?redirect=' + encodeURIComponent(CFG.pdpUrl);
    titleEl.textContent = 'You won ' + money(off * 100) + ' off';
    sayEl.textContent = '';
    showState('win');
    burstConfetti();
    playWinSound();
    var email = document.getElementById('g99-email');
    if (email) email.focus();
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function reveal() {
    writeState({ claimedAt: Date.now() });
    track('spin_wheel_code_claimed', { tier_won: wonPrize.amount, location: 'reveal' });
    showState('reveal');
    burstConfetti();
    var link = document.getElementById('g99-claim-link');
    if (link) link.focus();
  }

  /* copy-code button */
  var copyBtn = document.getElementById('g99-copy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = (readState().code || wonPrize && wonPrize.code || '').trim();
      if (!code) return;
      var done = function () { copyBtn.textContent = 'Copied!'; setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code); done(); });
      } else { fallbackCopy(code); done(); }
    });
  }
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  /* Capture uses the real Shopify {% form 'customer' %} so Shopify's bot
     protection attaches on the user's own submit. It posts into a hidden iframe
     so the visible page never navigates. We reveal on the iframe load, and also
     on a fallback so the customer never loses the prize. */
  var form = document.getElementById('g99-form');
  var sink = document.getElementById('g99-sink');
  var pendingClaim = false;
  var captureTimer = null;

  function finishCapture(ok) {
    if (!pendingClaim) return;
    pendingClaim = false;
    if (captureTimer) { clearTimeout(captureTimer); captureTimer = null; }
    track(ok ? 'spin_wheel_email_submitted' : 'spin_wheel_capture_failed', { tier_won: wonPrize.amount });
    reveal();
  }
  function challengeVisible() {
    var f = document.querySelector('iframe[src*="hcaptcha.com"]');
    return !!(f && f.offsetWidth > 30 && f.offsetParent !== null);
  }
  function armFallback(ms) {
    if (captureTimer) clearTimeout(captureTimer);
    captureTimer = setTimeout(function () {
      if (pendingClaim && challengeVisible()) { armFallback(15000); return; }
      finishCapture(false);
    }, ms);
  }

  if (form && sink) {
    sink.addEventListener('load', function () { finishCapture(true); });
    form.addEventListener('submit', function (e) {
      var input = document.getElementById('g99-email');
      var err = document.getElementById('g99-email-err');
      var email = (input.value || '').trim();
      if (!validEmail(email)) { e.preventDefault(); err.hidden = false; input.focus(); return; }
      err.hidden = true;
      var tags = document.getElementById('g99-tags');
      if (tags) tags.value = '9.9-spinwheel,spin-' + wonPrize.amount;
      var claimBtn = document.getElementById('g99-claim');
      claimBtn.disabled = true;
      claimBtn.textContent = 'Saving...';
      pendingClaim = true;
      armFallback(12000);
      /* no preventDefault: the real Shopify form POSTs into the hidden iframe */
    });
  }

  /* ---------- trigger: once, 3s after load, never again ---------- */
  function maybeAutoOpen(trigger) {
    if (!armed) return;
    armed = false;
    if (!root.hidden) return;
    if (readState().seenAt) return;
    if (root.dataset.suppressed === '1') return;
    openModal(trigger);
  }
  if (!readState().seenAt && root.dataset.suppressed !== '1') {
    setTimeout(function () { maybeAutoOpen('delay'); }, 3000);
  } else {
    armed = false;
  }

  window.giftySpin99 = { open: function () { openModal('manual'); }, state: readState };
})();
